import { Box, Center, Spinner } from '@chakra-ui/react';

export const InlineLoadingSpinner = (spinnerProps: any) => {
  return (
    <Center>
      <Spinner {...spinnerProps} size="xl" thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" />
    </Center>
  );
};

export const ButtonSpinner = (spinnerProps: any) => {
  return (
    <Center>
      <Spinner {...spinnerProps} size="sm" thickness="2px" speed="0.65s" color="gray.200" emptyColor="blue.500" />
    </Center>
  );
};

export const LoadingSpinner = ({ noMargin }: { noMargin?: boolean }) => {
  return (
    <Center>
      <Spinner size="xl" m={noMargin ? 0 : 200} thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" />
    </Center>
  );
};

export const LoadingOverlay = () => {
  return (
    <Box position="fixed" zIndex="999" left="0" top="0" w="full" h="full" overflow="auto" opacity={0.9} mt={'0 !important'} bg={'whitesmoke'} p={20}>
      <LoadingSpinner />
    </Box>
  );
};
